import React, { useEffect, useState } from 'react';
import HeaderCommun from './HeaderCommun';
import axios from 'axios';

const rawNavigation = [
  {
    name: 'Dashboard',
    href: '/recruteur/dashboard',
    permissionKey: 'dashboard',
    guideClass: 'guide-dashboard'
  },
  {
    name: 'Missions',
    permissionKey: 'missions',
    guideClass: 'guide-missions',
    children: [
      { name: 'Toutes les missions', href: '/recruteur/Allmissions', permissionKey: 'missions' },
      { name: 'Mes missions', href: '/recruteur/Mesmissions', permissionKey: 'missions' },
      { name: 'Mes favoris', href: '/recruteur/favoris', permissionKey: 'missions' }
    ]
  },
  {
    name: 'Mes Candidatures',
    href: '/recruteur/candidature',
    permissionKey: 'candidatures',
    guideClass: 'guide-candidatures'
  },
  {
    name: 'Mes top matches',
    href: '/recruteur/top-matches',
    permissionKey: 'topmatches',
    guideClass: 'guide-topmatches'
  },
  {
    name: 'Mes Talents',
    href: '/recruteur/talents',
    permissionKey: 'mesTalents',
    guideClass: 'guide-talents'
  },
  {
    name: 'Mes statistiques',
    href: '/recruteur/recruteur-stats',
    permissionKey: 'recruteur-stats',
    guideClass: 'guide-stats'
  }
];

const userNavigation = [
  { name: 'Profil', href: '/Recruteur/Profile', guideClass: 'guide-profil' },
  { name: 'Mes statistiques', href: '/Recruteur/Statistiques', guideClass: 'guide-user-stats' },
  { name: 'Factures', href: '/Recruteur/factures', guideClass: 'guide-factures' },
  // { name: 'Garanties', href: '/Garanties', guideClass: 'guide-garanties' },
  // { name: 'Aide', href: '/Aide', guideClass: 'guide-aide' },
  { name: 'Se déconnecter', guideClass: 'guide-logout' }
];

const HeaderRec = () => {
  const [filteredNav, setFilteredNav] = useState([]);
  const [cagnotte, setCagnotte] = useState(null);
  const [recruteurName, setRecruteurName] = useState(localStorage.getItem('recruteurName') || 'Recruteur');
  const [recruteurAvatar, setRecruteurAvatar] = useState(localStorage.getItem('recruteurAvatar') || null);

  const API_BASE = process.env.REACT_APP_API_BASE_URL;


  useEffect(() => {
    const fetchPermissions = async () => {
      const userType = localStorage.getItem('userType');
      if (!userType) return;
      try {
        const res = await axios.get(`${API_BASE}/api/roles/${userType.toLowerCase()}/permissions`);
        const permissions = res.data || {};
        const navWithAccess = rawNavigation
          .map(item => {
            if (item.children) {
              const children = item.children.filter(child => permissions[child.permissionKey]?.Accès);
              return children.length > 0 ? { ...item, children } : null;
            } else {
              return permissions[item.permissionKey]?.Accès ? item : null;
            }
          })
          .filter(Boolean);
        setFilteredNav(navWithAccess);
      } catch {
        setFilteredNav([]);
      }
    };

    const fetchCagnotte = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await axios.get(`${API_BASE}/api/recruteur-stats`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCagnotte(res.data?.cagnotte || null);
      } catch {
        setCagnotte(null);
      }
    };

    const handleStorageUpdate = () => {
      setRecruteurName(localStorage.getItem("recruteurName") || 'Recruteur');
      setRecruteurAvatar(localStorage.getItem("recruteurAvatar") || null);
    };

    fetchPermissions();
    fetchCagnotte();
    window.addEventListener("storage", handleStorageUpdate);
    return () => {
      window.removeEventListener("storage", handleStorageUpdate);
    };
  }, []);

  return (
    <HeaderCommun
      userName={recruteurName}
      navigation={filteredNav}
      userNavigation={userNavigation}
      cagnotte={cagnotte}
      userAvatar={recruteurAvatar ? `${API_BASE}${recruteurAvatar}?t=${Date.now()}` : null}
      addButtonLabel={null}
      addButtonHref={null}
      userRole="recruteur"
    />
  );
};

export default HeaderRec;
